import * as treauAPI from "@bohe-in/treau-api-client-ts";
import config from "../config/config";

export class TreauApiClient {
    adminsAPI: treauAPI.AdminsApi;
    devicesAPI: treauAPI.DevicesApi;
    usersAPI: treauAPI.UsersApi;
    optionsAPI: treauAPI.OptionsApi;
    constructor() {
        this.adminsAPI = new treauAPI.AdminsApi(undefined,config.treauApi.endpoint);
        this.devicesAPI = new treauAPI.DevicesApi(undefined,config.treauApi.endpoint);
        this.usersAPI = new treauAPI.UsersApi(undefined,config.treauApi.endpoint);
        this.optionsAPI = new treauAPI.OptionsApi(undefined,config.treauApi.endpoint);
    }
}
const treauApiClient = new TreauApiClient();

export default treauApiClient;
export {treauAPI as TreauAPI};